<!-- <ngx-spinner type="ball-scale-multiple"><p style="font-size: 20px; color: white">Please wait while your report is being generated...</p></ngx-spinner> -->
<app-loading *ngIf="!isLoaded"></app-loading>

<div *ngIf="isAuthorized && isLoaded">
    <div class="action-menu">
        <app-add-button (click)="add()"></app-add-button>
        <app-help-button (click)="displayHelpMessage=!displayHelpMessage"></app-help-button>
        <app-reports-button (click)="show_reports()"></app-reports-button>
    </div>

    <app-help-message [ngClass]="{'hide':!displayHelpMessage}"></app-help-message>

    <!-- <div *ngIf="showFiltersApp; else reportsApp"> -->
        <app-filters></app-filters>

        <div class='results' *ngIf="!isLoading">Results: {{total | number}}</div>

        <div class='index' infiniteScroll [infiniteScrollDistance]="3" [infiniteScrollThrottle]="50" (scrolled)="getCourses()">

            <div class='row title'>
                <div class='col-sm-1'>ID</div>
                <div class='col-sm-11'>Course</div>
            </div>

            <div class='row' *ngIf='total === 0'>
                <div class='col-sm-12 text-center'>
                    <div *ngIf="!loadingError">There are no Courses and Events to report.</div>
                    <div *ngIf="loadingError">An error occurred, and we were unable to load Courses and Events.</div>
                </div>
            </div>

            <div *ngFor="let course of courses" class='row' (click)="open(course.id)" style='cursor: pointer;'>
                <div class='col-sm-1'>{{course.id}}</div>
                <div class='col-sm-11'>
                    <div>{{course.name | titlecase}}</div>
                    <div style='font-size:0.9em;'>
                        <div style='margin-top:0.25em;'>{{course.region.displayName}}</div>
                        <div style='margin-top:0.25em;'>{{course.structure.name | titlecase}}</div>
                        <div style='margin-top:0.25em;' *ngIf="course.startDate">
                            {{course.startDate}}
                            <span *ngIf="course.endDate"> - {{course.endDate}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!isAuthorized || isLoading">
                <app-loading [isLoading]="isLoading"></app-loading>
            </div>
        </div>
    <!-- </div> -->
    <!-- <ng-template #reportsApp>
        <div>
            <app-reports></app-reports>
        </div>
    </ng-template> -->

</div>